import { useEffect, useState } from "react";
import { _CompetitionType, _Entailment, _FunctionalCompetence, _MacroProcess } from "../../../../core/services/dataBean/EntityCatalog";

import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { MainThemeEditor } from "../MainTheme/MainTheme.editor";
import { EntailmentEditor } from "../Entailment/Entailment.editor";
import { FuncionalsFamilyEditor } from "../FunctionalsFamily/FuncionalsFamily.editor";
import { PerformanceCriteria } from "./PerformanceCriteria";
import { AppointmentEditor } from "../Appointment/Appointment.editor";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { InputMoney } from "../../../theme/Input/InputMoney";




export const FuncionalCompetence = () => {

    const FuncionalCompetence = useDataBean(_FunctionalCompetence);

    const single = Singleton.getInstance();
    const [compMainTheme, setMainThemeCompType] = useState<number>(null)
    const [Entailment, setEntailment] = useState<number>(null)
    const [funcionals, setfuncionals] = useState<number>(null)
    const [appoiment, setAppoiment] = useState<number>(null)
    const [lista, setLista] = useState<any>([]);
    const [modalcriterios, setModalcriterios] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    

    const getLista = () => {

        FuncionalCompetence.instance.getFunctionalCompetenceCatalog(compMainTheme, Entailment, funcionals).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    //console.log(resp)
                }
            }
        )

    }

    const create = () => {
        FuncionalCompetence.setBean({
            IDMainTheme: compMainTheme,
            IDEntailment: Entailment,
            IDFamily: funcionals,
            IDAssignment:appoiment

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        FuncionalCompetence.deleteItemVoid(FuncionalCompetence.bean.IDFunctionalCompetence).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(FuncionalCompetence.bean);
        FuncionalCompetence.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDFunctionalCompetence', visible: false },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },


    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Criterios de Desempeño', icono: 'ri-file-user-line', visible: true, evento: () => { setModalcriterios({ ...modalcriterios, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const setBean2=(item)=>{
        item.Levels = appoiment;
        FuncionalCompetence.setBean(item);
    }


    return (
        <BasicPage titulo="Diccionario de Competencias Funcionales ">
            <div className="row">
                <div className="col-md-4"> <MainThemeEditor idSelector={compMainTheme} onChange={(e) => { setMainThemeCompType(e) }} /></div>
                <div className="col-md-4">
                    <label>Nivel</label>
                    <AppointmentEditor  label=" "
                        idSelector={appoiment}                        
                        returnType="Object"
                        onChange={(e) => { setAppoiment(e.IDAppointment); setEntailment(e.IDEntailment); FuncionalCompetence.setBean({...FuncionalCompetence.bean,"IDAssignment":e}) }} />
                </div>
                <div className="col-md-4">   <EntailmentEditor  idSelector={Entailment} onChange={(e) => { setEntailment(e) }} /></div>
                <div className="col-md-4"><FuncionalsFamilyEditor idSelector={funcionals} onChange={(e) => { setfuncionals(e) }} /></div>
                <div className="col-md-4">
                    <BasicButton useMargin icon="" eventClick={()=>{getLista()}}>Buscar</BasicButton>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={setBean2} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="number" name="Code" className="form-control" value={FuncionalCompetence.bean.Code} onChange={FuncionalCompetence.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={FuncionalCompetence.bean.Name} onChange={FuncionalCompetence.handleChange} />
                            </div>
                            <div className="col-md-12">
                                <label>Description</label>
                                <input type="text" name="Description" className="form-control" value={FuncionalCompetence.bean.Description} onChange={FuncionalCompetence.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Puntaje esperado</label>
                                <InputMoney _style="decimal" _value={FuncionalCompetence.bean.ExpectedPercentLevel}
                                 onChange={(e)=>{FuncionalCompetence.setBean({...FuncionalCompetence.bean,"ExpectedPercentLevel":e})}}/>
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalcriterios} updateModal={setModalcriterios} eventModal={editaItem}>
                        <PerformanceCriteria IDFunctionalCompetence={FuncionalCompetence.bean.IDFunctionalCompetence} />
                    </Modal>

                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}